import httpClient from "@/services/base.service.js";

export default {
  get: function () {
    return httpClient.get("/api/v1/membershipplan");
  }
};
